<div class="saved-jobs-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="loading-text">{{ 'pages.jobs.saved.loading' | transloco }}</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <i class="fas fa-exclamation-circle error-icon"></i>
    <h3 class="error-title">{{ 'pages.jobs.saved.error.title' | transloco }}</h3>
    <p class="error-message">{{ error }}</p>
    <button
      mat-raised-button
      color="primary"
      (click)="loadSavedJobs()"
      class="retry-button">
      <i class="fas fa-sync"></i>
      {{ 'pages.jobs.saved.error.retry' | transloco }}
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !error && savedJobs.length === 0" class="empty-state">
    <i class="fas fa-bookmark empty-icon"></i>
    <h3 class="empty-title">{{ 'pages.jobs.saved.empty.title' | transloco }}</h3>
    <p class="empty-message">{{ 'pages.jobs.saved.empty.message' | transloco }}</p>
    <a
      [routerLink]="getLocalizedRoute('/')"
      mat-raised-button
      color="primary"
      class="browse-jobs-button">
      <i class="fas fa-search"></i>
      {{ 'pages.jobs.appliedJobs.empty.browseJobs' | transloco }}
    </a>
  </div>

  <!-- Jobs List -->
  <div *ngIf="!isLoading && !error && savedJobs.length > 0" class="saved-jobs-list">
    <!-- Header with count -->
    <div class="saved-jobs-header">
      <h2>{{ 'pages.jobs.saved.title' | transloco }}</h2>
      <div class="header-controls">
        <p class="jobs-count">
          {{ 'pages.jobs.saved.count' | transloco: { count: totalJobs } }}
        </p>
        <div class="limit-selector">
          <label for="saved-limit-select" class="limit-selector__label">
            {{ 'pages.jobs.saved.showJobs' | transloco }}:
          </label>
          <div class="limit-selector__wrap">
            <select
              id="saved-limit-select"
              class="limit-selector__select"
              [value]="pageSize"
              (change)="onLimitChange(+$any($event.target).value)">
              <option *ngFor="let opt of limitOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <i class="fas fa-chevron-down limit-selector__chevron" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Jobs Grid -->
    <div class="jobs-grid">
      <app-job-detail-card
        *ngFor="let job of savedJobs; trackBy: trackByJobId"
        [job]="mapJobToCardData(job)"
        mode="saved"
        [isUnsaving]="unsavingJobId === job.id"
        [jobDetailRoute]="getLocalizedRoute('/job/' + job.id)"
        (unsaveJob)="unsaveJob($event)">
      </app-job-detail-card>
    </div>

    <!-- Load More Button -->
    <app-load-more-button
      *ngIf="hasMore"
      [totalItems]="totalJobs"
      [shownItems]="savedJobs.length"
      [remainingCount]="remainingCount"
      [isLoading]="loadingMore"
      (loadMore)="loadMore()">
    </app-load-more-button>
  </div>
</div>
